/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editreplace1Inputs */

const en_editreplace1 = /** @type {(inputs: Editreplace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace image`)
};

const de_editreplace1 = /** @type {(inputs: Editreplace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild ersetzen`)
};

/**
* | output |
* | --- |
* | "Replace image" |
*
* @param {Editreplace1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editreplace1 = /** @type {((inputs?: Editreplace1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editreplace1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editreplace1(inputs)
	return de_editreplace1(inputs)
});
export { editreplace1 as "editReplace" }